import React from 'react';
import brain1 from './img/brain-1.svg';
import brain2 from './img/brain-2.svg';
import brain3 from './img/brain-3.svg';
import brain4 from './img/brain-4.svg';
import brain5 from './img/brain-5.svg';
import { StudyGuideModalLegendBrain } from '../study-guide-modal-legend/study-guide-modal-legend-brain';
import { GuideLvlContent, GuideLvlSubtitle, GuideLvlTag, GuideLvlTagImg, GuideLvlTagImgWrapper, GuideLvlTagText, GuideLvlTitle, GuideLvlTooltip } from '@/components/custom/guide';

export function StudyGuideMyGuideLvlTag(props) {
  const { percentage = 0, id } = props;

  const tooltipId = String(id);

  const item =
    percentage <= 20
      ? {
          src: brain1,
          title: 'Começando a entender',
          subtitle: 'Você está dando os primeiros passos no aprendizado deste conteúdo. As informações ainda são novas, e é normal que leve um tempo para assimilar tudo. Continue estudando para aprofundar o entendimento.',
          modifier: 'danger'
        }
      : percentage > 20 && percentage <= 40
        ? {
            src: brain2,
            title: 'Ganhando clareza',
            subtitle: 'Você já está começando a se familiarizar com os conceitos. O conhecimento está se firmando e as ideias estão ficando mais claras. Mantenha o ritmo para solidificar o aprendizado.',
            modifier: 'third'
          }
        : percentage > 40 && percentage <= 60
          ? {
              src: brain3,
              title: 'Conteúdo assimilado',
              subtitle: 'Você já absorveu boa parte do conteúdo e está se tornando mais confiante. Os conceitos principais estão sendo compreendidos, e você está no caminho certo para dominar o assunto.',
              modifier: 'warning'
            }
          : percentage > 60 && percentage <= 80
            ? {
                src: brain4,
                title: 'Boa retenção',
                subtitle: 'Você está retendo a maior parte do conteúdo com sucesso. Suas habilidades e conhecimento estão bem desenvolvidos, e você está quase pronto para aplicar o que aprendeu de forma prática.',
                modifier: 'success-light'
              }
            : {
                src: brain5,
                title: 'Ótima retenção',
                subtitle: 'Parabéns! Você atingiu um nível excelente de retenção de conhecimento. Agora, você domina o conteúdo e está preparado para utilizá-lo com confiança em diferentes contextos.',
                modifier: 'success'
              };

  return (
    <>
      <GuideLvlTag
        variant={item?.modifier}
        data-tooltip-id={`${tooltipId}-tooltip`}
        data-tooltip-place="top-end"
      >
        <GuideLvlTagText title={item?.title}>{item?.title}</GuideLvlTagText>
        <GuideLvlTagImgWrapper>
          <GuideLvlTagImg
            src={item?.src}
            alt="cérebro"
          />
        </GuideLvlTagImgWrapper>
      </GuideLvlTag>

      <GuideLvlTooltip id={`${tooltipId}-tooltip`}>
        <StudyGuideModalLegendBrain percentage={percentage} />

        <GuideLvlContent>
          <GuideLvlTitle>{item?.title}</GuideLvlTitle>
          <GuideLvlSubtitle>{item?.subtitle}</GuideLvlSubtitle>
        </GuideLvlContent>
      </GuideLvlTooltip>
    </>
  );
}
